export default __webpack_public_path__ + "static/media/editAssessment.ff58cf9f.svg";